"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryTooSlowRule = void 0;
exports.isQueryTooSlow = isQueryTooSlow;
const zod_1 = require("zod");
const utils_1 = require("@azimutt/utils");
const databaseUtils_1 = require("../../databaseUtils");
const duration_1 = require("../../helpers/duration");
const sql_1 = require("../../helpers/sql");
const connector_1 = require("../../interfaces/connector");
const rule_1 = require("../rule");
const ruleId = 'query-too-slow';
const ruleName = 'too slow query';
const ruleDescription = 'queries with mean execution time over the threshold';
const CustomRuleConf = rule_1.RuleConf.extend({
    ignores: connector_1.QueryId.array().optional(),
    maxMs: zod_1.z.number(),
}).strict().describe('QueryTooSlowConf');
exports.queryTooSlowRule = {
    id: ruleId,
    name: ruleName,
    description: ruleDescription,
    conf: { level: rule_1.RuleLevel.enum.high, maxMs: 1000 },
    zConf: CustomRuleConf,
    analyze(conf, now, db, queries, history, reference) {
        const refIgnores = reference.map(r => r.extra?.queryId).filter(utils_1.isNotUndefined);
        const ignores = refIgnores.concat(conf.ignores || []);
        return queries
            .filter(q => isQueryTooSlow(q, conf.maxMs))
            .filter(q => !ignores.some(i => i === q.id))
            .sort((a, b) => -((a.exec?.meanTime || 0) - (b.exec?.meanTime || 0)))
            .map(q => {
            const entity = (0, sql_1.getMainEntity)(q.query);
            const { id, database, query, ...stats } = q;
            return (0, utils_1.removeUndefined)({
                ruleId,
                ruleName,
                ruleLevel: conf.level,
                message: `Query ${q.id}${entity ? ` on ${(0, databaseUtils_1.entityRefToId)(entity)}` : ''} is too slow (${(0, duration_1.showDuration)(q.exec?.meanTime || 0)}, ${(0, sql_1.formatSql)(q.query)}).`,
                entity,
                extra: { queryId: id, query, stats, entities: (0, sql_1.getEntities)(q.query) }
            });
        });
    }
};
function isQueryTooSlow(query, maxMs) {
    return (query.exec?.meanTime || 0) > maxMs;
}
//# sourceMappingURL=queryTooSlow.js.map